import {useDispatch, useSelector} from "react-redux";
import {useEffect, useRef, useState} from "react";
import {deleteHistory, loadMyDesign, updateHistory} from "../api/designHistoryApi";
import {introAction, optionAction, overlayPanelAction} from "../../../redux/store";
import {useParams} from "react-router-dom";
import Alert from "../component/molecules/Alert";
import useHistory from "./useHistory";
import {loadDataAndSet} from "../../../redux/optionWindow-slice/optionWindowSlice";

const useHistoryDetail = (item) => {
  const {title, description, bespokeCode, customerId } = item;

  const dispatch = useDispatch();
  const containerRef = useRef();
  const params = useParams();
  const paramsId = params?.id?.toLowerCase();
  const { getConfigurationList } = useHistory();

  const deviceType = sessionStorage.getItem("deviceType");

  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    title: title,
    description: description,
  });



  useEffect(() => {
    containerRef.current &&
    containerRef.current.addEventListener("wheel", (e) => {
      e.stopPropagation();
    }, { passive: false })
  }, []);



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  }


  const toggleEditModeHandler = (value) => {
    if (value !== undefined) {
      setIsEditing(value);
    } else {
      setIsEditing(!isEditing);
    }
  }


  const handleLoadDesign = async (closeModal, closeSubModal) => {
    const configDataLoad = loadMyDesign(bespokeCode);
    configDataLoad.then(res => {
      const {result, message, data} = res.data;
      if (result && message === "SUCCESS") {
        const {config_data, productCode} = data;

        const setConfig = new Promise(resolve => {
          // resolve(dispatch(optionAction.setLoadData(config_data)));
          resolve(dispatch(loadDataAndSet({ processedData: config_data, colorway: config_data.COLORWAY })));
        });

        setConfig.then(() => {
          setTimeout(() => {
            closeModal();
            closeSubModal();
            dispatch(overlayPanelAction.setIsOverlayPanelActive(false));
            if (paramsId !== productCode) {
              dispatch(introAction.setLoadingState("loading"));
              window.location.href = `/en/${productCode.toLowerCase()}/configurator/exterior`
            }

          },100)
        });
      }

    });
  }


  const handleUpdateHistory = (formData, subModalMount, closeModal, closeSubModal) => {

    const payload = {
      title: formData.title,
      description: formData.description,
    }
    try {
      updateHistory(customerId, bespokeCode, payload).then(res => {
        const { result, message, data } = res.data;
        if (result && message === "SUCCESS") {
          closeSubModal();

          subModalMount(
            <Alert title={message}
                   message={"Successfully updated."}
                   closeModal={closeModal}
                   closeSubModal={closeSubModal}
                   callback={() => {
                     getConfigurationList(customerId);
                   }}
            />, true
          )

        }
      });
    } catch (e) {
      console.log(e);

    }

  }

  const handleDeleteHistory = (closeModal, closeSubModal, subModalMount) => {
    deleteHistory(customerId, bespokeCode).then(res => {
      const {result, message} = res.data;
      if (result && message === "SUCCESS") {
        closeSubModal();

        subModalMount(
          <Alert title={message}
                 message={"Successfully deleted."}
                 closeModal={closeModal}
                 closeSubModal={closeSubModal}
                 callback={() => {
                   getConfigurationList(customerId);
                 }}
          />, true
        )

      }
    });
  }






  return {deviceType, containerRef, isEditing, formData, toggleEditModeHandler, handleLoadDesign, handleInputChange, handleUpdateHistory, handleDeleteHistory }
}

export default useHistoryDetail;
